export const AUTH = 'signup';
export const AUTH_SIGNIN = 'signin';
export const AUTH_VERIFY = 'verify';
export const AUTH_PASSWORD_RESET = 'resetpassword';
export const AUTH_PASSWORD_SET = 'reset'; // This is tied to a link in internal-apis - don't change this

export const AUTH_WALLET_PASSWORD = 'walletpassword';
export const BACKUP = 'backup';
export const CHANNEL = 'channel';
export const DISCOVER = 'discover';
export const ARTISTS = 'artists';
export const SPORTS = 'sports';
export const BIG_HITS = 'bighits';
export const CREATIVE_ARTS = 'arts';
export const MOVIES = 'movies';
export const MUSIC = 'music';
export const COMMUNITY = 'community';
export const CONTRIBUTE = 'contribute';
export const DOCS_AND_FILMS = 'docs';
export const EDUCATION = 'education';
export const ENLIGHTENMENT = 'enlightenment';
export const FEATURED = 'featured';
export const FINANCE = 'finance';
export const GAMING = 'gaming';
export const GENERAL = 'general';
export const LAB = 'lab';
export const NEWS = 'news';
export const POP_CULTURE = 'popculture';
export const RABBIT_HOLE = 'rabbithole';
export const SCIENCE = 'science';
export const TECHNOLOGY = 'technology';
export const TECH = 'tech';
export const UNIVERSE = 'universe';
export const WILD_WEST = 'wildwest';
export const HOME = 'home';
export const HELP = 'help';
export const LIBRARY = 'library';
export const LISTS = 'lists';
export const PLAYLISTS = 'playlists';
export const WATCH_HISTORY = 'watchhistory';
export const INVITE = 'invite';
export const FEATURED_CHANNELS = 'featured_channels';
export const DEPRECATED__DOWNLOADED = 'downloaded';
export const DEPRECATED__PUBLISH = 'publish';
export const DEPRECATED__PUBLISHED = 'published';
export const UPLOAD = 'upload';
export const POST = 'post';
export const UPLOADS = 'uploads';
export const GET_CREDITS = 'getcredits';
export const REPORT = 'report';
export const REPORT_CONTENT = 'report_content';
export const REWARDS = 'rewards';
export const REWARDS_VERIFY = 'rewards/verify';
export const REPOST_NEW = 'repost';
export const SEND = 'send';
export const SETTINGS = 'settings';
export const SETTINGS_STRIPE_ACCOUNT = 'settings/tip_account';
export const SETTINGS_NOTIFICATIONS = 'settings/notifications';
export const SETTINGS_BLOCKED_MUTED = 'settings/block_and_mute';
export const SETTINGS_CREATOR = 'settings/creator';
export const SETTINGS_UPDATE_PWD = 'settings/update_password';
export const SETTINGS_OWN_COMMENTS = 'settings/ownComments';
export const SHOW = 'show';
export const ACCOUNT = 'account';
export const SEARCH = 'search';
export const TAGS_FOLLOWING = 'tags';
export const DEPRECATED__TAGS_FOLLOWING = 'following/tags';
export const TAGS_FOLLOWING_MANAGE = 'tags/manage';
export const DEPRECATED__TAGS_FOLLOWING_MANAGE = 'tags/following/manage';
export const DEPRECATED__CHANNELS_FOLLOWING = 'following/channels';
export const CHANNELS_FOLLOWING = 'following';
export const DEPRECATED__CHANNELS_FOLLOWING_MANAGE = 'following/channels/manage';
export const CHANNELS_FOLLOWING_DISCOVER = 'following/discover';
export const CHANNELS_FOLLOWING_MANAGE = 'following/manage';
export const WALLET = 'wallet';
export const CHANNELS = 'channels';
export const EMBED = 'embed';
export const TOP = 'top';
export const CREATOR_DASHBOARD = 'dashboard';
export const CHECKOUT = 'checkout';
export const CODE_2257 = '2257';
export const PRIVACY_POLICY = 'privacypolicy';
export const TOS = 'tos';
export const FYP = 'fyp';
export const YOUTUBE_TOS = 'youtubetos';
export const BUY = 'buy';
export const PAYMENTACCOUNT = 'paymentaccount';
export const ARACCOUNT = 'araccount';
export const RECEIVE = 'receive';
export const SWAP = 'swap';
export const CHANNEL_NEW = 'channel/new';
export const NOTIFICATIONS = 'notifications';
export const YOUTUBE_SYNC = 'youtube';
export const LIVESTREAM = 'livestream';
export const LIVESTREAM_CURRENT = 'live';
export const LIVESTREAM_CREATE = 'livestream/create';
export const LIST = 'list';
export const PLAYLIST = 'playlist';
export const ODYSEE_MEMBERSHIP = 'premium';
export const CREATOR_MEMBERSHIPS = 'memberships/creator';
export const MEMBERSHIPS_SUPPORTER = 'memberships/supporter';
export const MEMBERSHIPS_LANDING = 'memberships';
export const POPOUT = 'popout';
export const LATEST = 'latest';
export const LIVE_NOW = 'livenow';
export const PORTALS = 'portals';
export const PORTAL = 'portal';
export const CAREERS = 'careers';
export const CAREERS_IT_PROJECT_MANAGER = 'careers/it_project_manager';
export const CAREERS_SENIOR_BACKEND_ENGINEER = 'careers/senior_backend_engineer';
export const CAREERS_SENIOR_SYSADMIN = 'careers/senior_sysadmin';
export const CAREERS_SOFTWARE_SECURITY_ENGINEER = 'careers/software_security_engineer';
export const CAREERS_SENIOR_ANDROID_DEVELOPER = 'careers/senior_android_developer';
export const CAREERS_SENIOR_IOS_DEVELOPER = 'careers/senior_ios_developer';
export const ICONS_VIEWER = 'icons_viewer';
export const HIDDEN_CONTENT = 'hidden';
const PAGES = {
  ACCOUNT,
  ARACCOUNT,
  ARTISTS,
  AUTH,
  AUTH_PASSWORD_RESET,
  AUTH_PASSWORD_SET,
  AUTH_SIGNIN,
  AUTH_VERIFY,
  AUTH_WALLET_PASSWORD,
  BACKUP,
  BIG_HITS,
  BUY,
  CAREERS,
  CAREERS_IT_PROJECT_MANAGER,
  CAREERS_SENIOR_ANDROID_DEVELOPER,
  CAREERS_SENIOR_BACKEND_ENGINEER,
  CAREERS_SENIOR_IOS_DEVELOPER,
  CAREERS_SENIOR_SYSADMIN,
  CAREERS_SOFTWARE_SECURITY_ENGINEER,
  CHANNEL,
  CHANNELS,
  CHANNELS_FOLLOWING,
  CHANNELS_FOLLOWING_DISCOVER,
  CHANNELS_FOLLOWING_MANAGE,
  CHANNEL_NEW,
  CHECKOUT,
  COMMUNITY,
  CONTRIBUTE,
  CREATIVE_ARTS,
  CREATOR_DASHBOARD,
  CREATOR_MEMBERSHIPS,
  DEPRECATED__CHANNELS_FOLLOWING,
  DEPRECATED__CHANNELS_FOLLOWING_MANAGE,
  DEPRECATED__DOWNLOADED,
  DEPRECATED__PUBLISH,
  DEPRECATED__PUBLISHED,
  DEPRECATED__TAGS_FOLLOWING,
  DEPRECATED__TAGS_FOLLOWING_MANAGE,
  DISCOVER,
  DOCS_AND_FILMS,
  EDUCATION,
  EMBED,
  ENLIGHTENMENT,
  FEATURED,
  FEATURED_CHANNELS,
  FINANCE,
  FYP,
  GAMING,
  GENERAL,
  GET_CREDITS,
  HELP,
  HIDDEN_CONTENT,
  HOME,
  ICONS_VIEWER,
  INVITE,
  LAB,
  LATEST,
  LIBRARY,
  LIST,
  LISTS,
  LIVESTREAM,
  LIVESTREAM_CREATE,
  LIVESTREAM_CURRENT,
  LIVE_NOW,
  MEMBERSHIPS_LANDING,
  MEMBERSHIPS_SUPPORTER,
  MOVIES,
  MUSIC,
  NEWS,
  NOTIFICATIONS,
  ODYSEE_MEMBERSHIP,
  PAYMENTACCOUNT,
  PLAYLIST,
  PLAYLISTS,
  POPOUT,
  POP_CULTURE,
  PORTAL,
  PORTALS,
  POST,
  PRIVACY_POLICY,
  RABBIT_HOLE,
  RECEIVE,
  REPORT,
  REPORT_CONTENT,
  REPOST_NEW,
  REWARDS,
  REWARDS_VERIFY,
  SCIENCE,
  SEARCH,
  SEND,
  SETTINGS,
  SETTINGS_BLOCKED_MUTED,
  SETTINGS_CREATOR,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_OWN_COMMENTS,
  SETTINGS_STRIPE_ACCOUNT,
  SETTINGS_UPDATE_PWD,
  SHOW,
  SPORTS,
  SWAP,
  TAGS_FOLLOWING,
  TAGS_FOLLOWING_MANAGE,
  TECH,
  TECHNOLOGY,
  TOP,
  TOS,
  UNIVERSE,
  UPLOAD,
  UPLOADS,
  WALLET,
  WATCH_HISTORY,
  WILD_WEST,
  YOUTUBE_SYNC,
  YOUTUBE_TOS,
};
export default PAGES;
